export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f1564af48a469d2d208a7de11ad448e75519ff738&name=fetchTypeahead!'